mutation AccountingEntryStampProcessing(
  $input: AccountingEntryStampProcessingInput!
) {
  accountingEntryStampProcessing(input: $input) {
    processRequests {
      message
      isWarning
      isSuccess
      isFail
      id
      rowTimestamp
      reference
    }
  }
}
